<template>
  <div class="table_container">
    <el-row style="margin-bottom:10px">
      <el-form inline ref="searchForm" :model="searchForm">
        <el-form-item label="产品名称">
          <el-input v-model="searchForm.productName" placeholder="请输入产品名称" size="medium"/>
        </el-form-item>
          <el-form-item label="品类" prop="lessonType">
            <el-select @change="categoryChange" v-model="searchForm.categoryId" placeholder="请选择品类" style="width: 100%" size="medium">
              <el-option key="all" label="全部" value=""/>
              <el-option v-for="item in category" :key="item.id" :label="item.name"
                         :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="具体品类" prop="lessonType">
            <el-select v-model="searchForm.category2Id" placeholder="请选择具体品类" style="width: 100%" size="medium">
              <el-option key="all" label="全部" value=""/>
              <el-option v-for="item in category2" :key="item.id" :label="item.name"
                         :value="item.id"/>
            </el-select>
          </el-form-item>
        <el-form-item style="position: absolute; right: -10px">
          <el-button type="warning" icon="el-icon-search" @click="handleSearchSubmit" size="medium">查询</el-button>
          <el-button type="info" icon="el-icon-refresh-left" @click="handleSearchReset" size="medium">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd" size="medium">新建</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table highlight-current-row :data="tableData" border style="width: 100%">
        <el-table-column min-width="100" prop="productName" label="产品名称" align="center"/>
<!--        <el-table-column min-width="100" prop="basePrice" label="原价格" align="center"/>-->
        <el-table-column min-width="100" prop="nowPrice" label="价格" align="center"/>
        <el-table-column prop="categoryName" align="center" label="品类" min-width="150"/>
        <el-table-column prop="category2Name" align="center" label="具体品类" min-width="150" />
        <el-table-column min-width="100" prop="productAddr" label="产地" align="center"/>
        <el-table-column min-width="100" prop="productWeight" label="重量" align="center"/>
        <el-table-column min-width="100" prop="productMaterial" label="材质" align="center"/>
<!--        <el-table-column min-width="100" prop="productDetail" label="简介" align="center"/>-->
        <el-table-column width="200" label="操作" align="center">
          <template slot-scope="scope">
<!--            <el-tooltip :open-delay="700" effect="light" content="查看" placement="top-start">-->
<!--              <el-button @click="handleDetail(scope.$index, scope.row)"-->
<!--                         icon="el-icon-search" size="mini"/>-->
<!--            </el-tooltip>-->
            <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index,scope.row)" size="mini">编辑</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleDelete(scope.$index,scope.row)" size="mini">删除</el-button>
          </template>
        </el-table-column>
        <product-form ref="productForm"
                      :selRow="selRow"
                      :category="category"
                      @refreshList="getTableData"></product-form>
        <product-detail :detailVisible.sync="detailVisible" :selRow="selRow"/>
      </el-table>
    </el-row>
    <el-row class="table_pagination">
      <el-pagination background :pageCount="pageCount" :currentPage="currentPage" :page-size="pageSize"
                     layout="prev, pager, next" @current-change="handleCurPageChange"
                     hide-on-single-page/>
    </el-row>
  </div>
</template>

<script>
import {deleteProduct, getProductList} from "@/api/core/infoProduct";
import ProductForm from "@/views/core/product/modules/ProductForm";
import ProductDetail from "@/views/core/product/modules/ProductDetail";

export default {
  name: "Product",
  components: {ProductDetail, ProductForm},
  data() {
    return {
      tableData: [],
      searchForm: {},
      selRow: {},
      pageCount: 1,
      currentPage: 1,
      pageSize: 10,
      detailVisible: false,
      category: [],
      category2: []
    }
  },
  mounted() {
    this.getTableData();
    this.getInfoProductCategory();
  },
  methods:{
    async categoryChange(e){
      if(!e) {
        this.category2 = [];
        return
      }
      let {obj} = await this.postRequest('/core/infoProductCategory2/findListByPid',{pid: e});
      this.category2 = obj
    },
    async getInfoProductCategory() {
      let {obj} = await this.postRequest('/core/infoProductCategory/findAll');
      this.category = obj
    },
    handleCurPageChange(pageIndex) {
      if (pageIndex !== this.currentPage) this.currentPage = pageIndex;
      this.getTableData()
    },
    getTableData(){
      this.searchForm.pageNum = this.currentPage;
      this.searchForm.pageSize = this.pageSize;
      getProductList(this.searchForm).then(res => {
        console.log(res)
        if (res.status == 200) {
          this.tableData = res.obj.list
          this.pageCount = res.obj.pages
        }
      })
    },
    // 查询
    handleSearchSubmit() {
      this.currentPage = 1;
      this.getTableData()
    },
    // 重置
    handleSearchReset() {
      this.searchForm = {}
    },
    //  新建
    handleAdd() {
      this.selRow = {};
      this.$refs.productForm.visible = true;
    },
    // 序号
    generSerialNum(index) {
      return (this.currentPage - 1) * 10 + index + 1
    },
    //  修改
    handleEdit(index, row) {
      this.selRow = row;
      this.$refs.productForm.visible = true;
    },
    //  删除
    async handleDelete(index, row) {
      let isConfirm = await this.$confirm("确认删除？", '提示', {type: 'warning'}).catch(() => {
      });
      if (!isConfirm) return;
      let params = {id: row.id};
      await deleteProduct(params);
      this.getTableData()
    },
    handleDetail(index, row) {
      this.selRow = row;
      this.detailVisible = true;
    },
  }
}
</script>

<style scoped>

</style>